package com.karawek.core.ui.designcatalog.sections

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogMotion() {
    Text(
        text = "Motion",
        style = CoreTypography.title,
    )

    Text(
        text = "Motion is applied selectively using CoreMotion.\n" +
                "Exact timing and easing are platform-specific and refined when features require them.",
        style = CoreTypography.bodySecondary,
    )
}
